import { HOST, } from "common/constants";
import { Box, Container, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";

import scss from "./Education.module.scss";
import { HTag } from "components/HTag";
import { useTranslation } from "react-i18next";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

const Education = () => {
  const { t } = useTranslation();
  const [education, setEducation] = useState([]);

  const { i18n } = useTranslation();
  const currentLang = i18n.language;


  useEffect(() => {
    const fetchEducation = async () => {
      try {
        const res = await axios.get(`${HOST}/api/v1/education/`);
        setEducation(res.data.results || []);
      } catch (err) {
        console.error("Ошибка при получении данных об образовании:", err);
      }
    };

    fetchEducation();
  }, []);


  return (
    <Box>
      <Container>
        <Box className={scss.block}>
          <HTag tag="h2">{t("educationSection")}</HTag>

          <div className={scss.grid}>
            {education.map((item) => (
              <a className={scss.link} key={item.id} href={`/education/${item.id}`}>
                <Box className={scss.box}>
                  <img
                    src={item.image}
                    alt={item.title}
                    style={{ borderRadius: "10px" }}
                  />
                  <Typography className={scss.titleMore}>
                    {item[`title_${currentLang}`]}
                  </Typography>
                </Box>
              </a>
            ))}
          </div>
        </Box>
      </Container>
    </Box>
  );
};

export default Education;
